module.exports = __webpack_public_path__ + "img/flow3.87ce872b.png";